import * as React from 'react';

import Checklist from '@src/components/Lists/CheckList';
import GridOneCol from '@src/components/Grid/GridOneCol';
import GridTwoCol from '@src/components/Grid/GridTwoCol';
import PageSection from '@src/components/PageSection';
import {graphql} from 'gatsby';

interface BasicChecklistProps {
  basicChecklistContent: any;
}

interface ChecklistItem {
  heading: string;
  text: string;
}

const BasicChecklist = ({basicChecklistContent}: BasicChecklistProps) => {
  const columnLayout = basicChecklistContent.primary.column_layout;
  const sectionHeading = basicChecklistContent.primary.section_heading || null;
  let sectionContent = basicChecklistContent.primary.section_content;
  const checklistItems = basicChecklistContent.items;
  const checklistContent =
    checklistItems &&
    checklistItems.map(({heading, text}: ChecklistItem, i: number) => {
      return (
        <li key={i}>
          <p>
            <strong>{heading}</strong>
            <br />
            {text}
          </p>
        </li>
      );
    });

  if (sectionContent) {
    // Ensure we're not just outputting empty HTML tags from Prismic
    sectionContent = sectionContent.text ? sectionContent.html : null;
  }

  if (columnLayout === 'One Column') {
    return (
      <PageSection>
        <GridOneCol border="gray" gridType="small">
          {sectionHeading && <h2>{sectionHeading}</h2>}
          <div dangerouslySetInnerHTML={{__html: sectionContent}} />
          <Checklist>{checklistContent}</Checklist>
        </GridOneCol>
      </PageSection>
    );
  }

  if (columnLayout === 'Two Column') {
    const columnContent = {
      left_column: {html: `<h2>${sectionHeading}</h2>`},
      right_column: {html: sectionContent},
    };

    return (
      <PageSection>
        <GridTwoCol
          border="gray"
          gridType="wide"
          columnContent={columnContent}
          checklistContent={checklistContent}
        />
      </PageSection>
    );
  }
};

export default BasicChecklist;

export const basicChecklistFragment = graphql`
  fragment basicChecklist on PrismicPageDataBodyChecklist {
    id
    slice_type
    primary {
      column_layout
      section_heading
      section_content {
        html
        text
      }
    }
    items {
      heading
      text
    }
  }
`;
